import React from 'react';
import InvestorQueue from './InvestorQueue';

/** Investor queue for admins on project/portfolio bidding (parents gate access). */
const AdminControlPanel: React.FC = () => {
  return (
    <div className="card">
      <InvestorQueue />
    </div>
  );
};

export default AdminControlPanel;
